<template>
  <div class="ap-buyer clearfix" style="padding: 12px 0 30px;background: #f2f2f2;">
    <div class="main-width">
      <Side></Side>
      <div style="margin-left:160px">
        <router-view v-if="status=='APPROVED'"></router-view>
        <component :is="componentId"></component>
      </div>
    </div>
  </div>
</template>
<script>
import Side from "./Side.vue";

export default {
  data() {
    return {
      status: "",
      componentId: ""
    };
  },
  components: {
    Side,
    Auditing: () => import("./audit/Auditing.vue"),
    UnPassAudit: () => import("./audit/UnPassAudit.vue"),
    NoOrg: () => import("./audit/NoOrg.vue")
  },
  created() {
    this.getOrgDetail();
  },
  methods: {
    getOrgDetail() {
      // 通过审核显示路由内容。审核中、审核不通过、缺少组织显示对应组件
      this.$get("/spms/myProfiles/getOrgProfile", {}, { noFailureMsg: true })
        .then(res => {
          this.status = res.approvalStatus;
          if (this.status === "APPROVING") {
            this.componentId = "Auditing";
          } else if (this.status === "DISAPPROVED") {
            this.componentId = "UnPassAudit";
          } else if (this.status == "APPROVED") {
            this.componentId = "";
          } else {
            this.componentId = "NoOrg";
          }
        })
        .catch(err => {
          this.componentId = "NoOrg";
        });
    }
  }
};
</script>

<style lang="less">
// 审核通过、审核中、审核不通过、缺少组织的样式
.ap-buyer-index {
  .pass {
    float: right;
    background: #00a28a;
    color: #fff;
    border-radius: 18px;
    padding: 3px 8px;
    margin: 15px 15px 0 0;
  }
  .message {
    li {
      padding: 6px;
      color: #999;
      font-size: 12px;
      font-weight: normal;
      border-bottom: 1px solid rgba(34, 34, 48, 0.1);
      &:last-child {
        border: none;
      }
      &.active {
        .status {
          background: #00cc47;
        }
      }
      .cont {
        padding: 6px;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
      .status {
        border-radius: 50%;
        background: #ccc;
        margin: 9px 10px 0 0;
        width: 12px;
        height: 12px;
        float: left;
      }
      .time {
        padding: 6px;
      }
    }
  }
  .table {
    width: auto;
    margin-bottom: 0;
  }
  .account {
    padding: 15px 0 15px 20px;
    width: 180px;
    border-right: 1px solid #e4e4e4;
    cursor: pointer;
    &:hover {
      background: #e4e4e4;
    }
  }
  .corp {
    padding: 15px 0 0 20px;
  }
  .acc-info {
    .float-right {
      padding: 15px 30px 0 0;
    }
  }
  .acc-info,
  .item {
    background: #fff;
  }
  .item {
    overflow: hidden;
    margin-top: 18px;
    padding: 20px 23px;
    .title {
      margin-bottom: 20px;
      font-size: 1rem;
      font-weight: bold;
      a {
        float: right;
        color: #999;
        font-size: 0.8rem;
        text-decoration: underline;
      }
    }
    .table {
      td {
        width: 160px;
        text-align: center;
        font-size: 12px;
      }
      .number {
        padding: 0;
        a {
          display: block;
          padding: 20px;
          font-size: 24px;
          color: #666;
          font-weight: bold;
          &:hover {
            color: #000;
            background: #f2f2f2;
          }
        }
      }
      + .table {
        margin-left: 18px;
      }
    }
  }
}
</style>